import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TemplateService } from '../../services/template.service';
import { TemplateCardComponent } from '../../../shared/components/template-card/template-card.component';
import { Template } from '../../models/dtos/template.model';

@Component({
  selector: 'kt-app-template-select',
  standalone: true,
  imports: [CommonModule, TemplateCardComponent, RouterModule],
  templateUrl: './template-select.component.html',
  styleUrls: ['./template-select.component.scss']
})
export class TemplateSelectComponent implements OnInit {
  templateService = inject(TemplateService);
  router = inject(Router);

  templates: Template[] = [];
  selectedCategory = 'all';
  categories = ['all', 'professional', 'creative', 'minimal', 'corporate'];
  defaultTemplate : Template = undefined!;

  ngOnInit(): void {
    this.loadTemplates();
  }

  loadTemplates(): void {
    this.templateService.getStaticTemplates().subscribe({
      next: (res: Template[]) => {
        this.templates = res;
        this.defaultTemplate = this.templates.find(t => t.isDefault) as Template;
      }, error: (error) => {
        console.error('Failed to load templates:', error);
      }
    });
  }

  onTemplateSelect(template: Template): void {
    this.templateService.selectTemplate(template);
    this.router.navigate(['/invoice/form']);
  }

  onSkip(): void {
    this.templateService.selectTemplate(this.defaultTemplate);
    this.router.navigate(['/invoice/form']);
  }

  filterByCategory(category: string): void {
    this.selectedCategory = category;
  }

  get filteredTemplates(): Template[] {
    if (this.selectedCategory === 'all') {
      return this.templates;
    }
    return this.templates.filter((t) => t.category === this.selectedCategory);
  }
}
